// extracted by mini-css-extract-plugin
module.exports = {"banner":"F_cB","icon":"F_bj","title":"F_bF","text":"F_cC","button":"F_ck"};